var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"o-container o-container--responsive mv-64"},[_c('div',{staticClass:"u-align-center mv-64"},[_c('bl-button-av',{staticClass:"ph-48",attrs:{"size":"large"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n      "+_vm._s(_vm.$options.StartTransaction)+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }